import { parse as htmlToAst } from 'html-to-ast'

export const astToVue = (node: any, mapping: any) => {
  // console.log({ node })

  if (node.type === 'tag') {
    node.children = node.children.map((child: any) => {
      return astToVue(child, mapping)
    })

    const attrs = {
      ...node.attrs,
    }

    const map = mapping?.[node.name]

    switch (node.name) {
      // case 'a':
      //   attrs.to = attrs.href
      //   delete attrs.href
      //   return h(mapping?.[node.name] || node.name, attrs, {
      //     default: () => node.children,
      //   })
      default:
        return h(map || node.name, attrs, map
          ? {
              default: () => node.children,
            }
          : node.children)
    }
  }

  if (node.type === 'text') {
    return node.content
  }
}

export const html2Vue = (html: string, mapping: any) => {
  return htmlToAst(html).map((node: any) => astToVue(node, mapping)) || []
}
